import Vue from "vue";
import Router from "vue-router";
import Error from "@/views/404";
import Main from "@/views/parentpage";

// //核心代码
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: "/#/",
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
  routes: [
    {
      path: "/page",
      component: Main,
      children: [
        {
          path: "/news/detail",
          component: (resolve) => require(["../views/newsdetail.vue"], resolve),
        },
        {
          path: "/news/list",
          name: "newslist",
          component: (resolve) => require(["../views/newslist.vue"], resolve),
        },
        {
          path: "/pub/detail",
          name: "pubdetail",
          component: (resolve) => require(["../views/pubdetail.vue"], resolve),
        },
        {
          path: "/pub/list",
          name: "publist",
          component: (resolve) => require(["../views/publist.vue"], resolve),
        },
        {
          path: "/info",
          name: "infopage",
          component: (resolve) => require(["../views/info.vue"], resolve),
        },
        {
          path: "/partner",
          name: "partnerpage",
          component: (resolve) => require(["../views/partner.vue"], resolve),
        },
        {
          path: "/business/detail",
          name: "businessdetail",
          component: (resolve) =>
            require(["../views/businessdetail.vue"], resolve),
        },
        {
          path: "/business/list",
          name: "businesslist",
          component: (resolve) =>
            require(["../views/businesslist.vue"], resolve),
        },
        {
          path: "/job/info",
          name: "jobinfo",
          component: (resolve) =>
            require(["../views/employ/info.vue"], resolve),
        },
        {
          path: "/job/find/list",
          name: "jobfindlist",
          component: (resolve) =>
            require(["../views/employ/joblist.vue"], resolve),
        },
        {
          path: "/job/find/detail",
          name: "jobfinddetail",
          component: (resolve) =>
            require(["../views/employ/jobdetail.vue"], resolve),
        },
        {
          path: "/job/care/list",
          name: "jobcarelist",
          component: (resolve) =>
            require(["../views/employ/userlist.vue"], resolve),
        },
        {
          path: "/job/care/detail",
          name: "jobcaredetail",
          component: (resolve) =>
            require(["../views/employ/userdetail.vue"], resolve),
        },
        {
          path: "/party/detail",
          name: "partydetail",
          component: (resolve) =>
            require(["../views/partydetail.vue"], resolve),
        },
        {
          path: "/party/list",
          name: "partylist",
          component: (resolve) => require(["../views/partylist.vue"], resolve),
        },
      ],
    },
    {
      path: "/page1",
      component: (resolve) => require(["../views/main.vue"], resolve),
    },
    {
      path: "/page2",
      component: (resolve) => require(["../views/main.vue"], resolve),
    },
    {
      path: "/page3",
      component: (resolve) => require(["../views/main.vue"], resolve),
    },
    {
      path: "/page4",
      component: (resolve) => require(["../views/main.vue"], resolve),
    },
    {
      path: "/page5",
      component: (resolve) => require(["../views/main.vue"], resolve),
    },
    {
      path: "/page6",
      component: (resolve) => require(["../views/main.vue"], resolve),
    },
    // {
    //   path: '/test',
    //   component: resolve => require(['../views/test.vue'], resolve)
    // },
    {
      path: "/",
      component: (resolve) => require(["../views/main.vue"], resolve),
    },
    {
      path: "*",
      component: Error,
    },
  ],
});
